import * as React from 'react';
import { SortableHandle } from 'react-sortable-hoc';

/**
 * This component is the drag handle users click and hold on to rearrange the columns
 */
export const DragHandle = SortableHandle(() => (
    <i
        className="fas fa-bars fa-2x"
        style={{ cursor: 'move', marginLeft: 8, msUserSelect: 'none' }}
    />
));
